import { render } from "./GraphicalExplanation1.vue?vue&type=template&id=6bd33e0d&scoped=true"
import script from "./GraphicalExplanation1.vue?vue&type=script&lang=js"
export * from "./GraphicalExplanation1.vue?vue&type=script&lang=js"

import "./GraphicalExplanation1.vue?vue&type=style&index=0&id=6bd33e0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd33e0d"]])

export default __exports__